// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zCF-","label":"styles_label__1IP-X"};